import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Button, Image } from 'react-bootstrap'
import imgDownload from '../../../images/Download_Outline.svg'
import Swal from 'sweetalert2'
import { htmlToPdfmake, pdfMake } from '../../../lib/pdf-make'
import NavContract from './contract-nav'
import { useSelector } from 'react-redux'
import {
  getContractDetailFileAPI,
  updateSecretAPI
} from '../../../services/contract'
import SwalCustom from '../../../alert/swal-custom'
import Error_false from '../../error/error-false'
import moment from 'moment'
import { TXTSUCCESS } from '../../../Constants'

export default function ContractSecretNav({
  data,
  isCheck2,
  signatureVP,
  signatureEMP,
  signatureTO,
  signatureCEO,
  getContractDetail
}) {
  const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const contractNo = searchParams.get('contractNo')

  const getContractDetailFile = async () => {
    const docTypeId = 1
    const body = { orgId, contractNo, docTypeId }
    const result = await getContractDetailFileAPI(body)
    if (!result) return
    if (result.status && result) {
      window.open(result.result[0]?.url)

      // setDetailFile(result.result[0]?.url);
    }
  }
  const exportPDF = async (isChecked) => {
    try {
      const html = htmlToPdfmake(ContractSecretNav ? ContractSecretNav : `-`, {
        defaultStyles: {}
      })
      const file = pdfMake.createPdf({
        images: {
          imgsky:
            data.org_id === 1
              ? `${window.location.origin}/image/SKY.png`
              : data.org_id === 2
                ? `${window.location.origin}/image/MT.jpg`
                : data.org_id === 3
                  ? `${window.location.origin}/image/ASTRO.png`
                  : data.org_id === 5
                    ? `${window.location.origin}/image/ProInside.png`
                    : `${window.location.origin}/image/White.png`,
          imgSignatureEMP:
            signatureEMP?.url || `${window.location.origin}/image/White.png`,
          imgSignaturePD:
            signatureVP?.url || `${window.location.origin}/image/White.png`,
          imgSignatureCEO:
            signatureCEO?.url || `${window.location.origin}/image/White.png`,
          imgSignatureTO:
            signatureTO?.url || `${window.location.origin}/image/White.png`
        },

        info: {
          title: 'สัญญาการเก็บรักษาข้อมูลที่เป็นความลับ'
        },
        // watermark: { text: "ตัวอย่าง", opacity: 0.1 },
        header: function (cp, pc, ps) {
          //add logic
          return {
            columns: [
              {
                image: 'imgsky',
                alignment: 'left',
                width: 60,
                marginTop: 40,
                marginLeft: 40,
                marginBottom: 10
              },
              {
                text: contractNo,
                bold: true,
                opacity: 0.5,
                alignment: 'right',
                margin: [0, 20, 20, 0]
              }
            ]
          }
        },
        content: [
          // {
          //   image: "imgsky",
          //   alignment: "left",
          //   width: 60,
          //   marginTop: 5,
          //   marginBottom: 10,
          // },
          {
            text: 'สัญญาการเก็บรักษาข้อมูลที่เป็นความลับ',
            bold: true,
            alignment: 'center',
            marginTop: 0,
            fontSize: 14
          },
          {
            text: `ทำที่ ${data?.org_th || '-'}`,
            bold: false,
            alignment: 'right',
            marginTop: 15,
            marginBottom: 2
          },

          {
            text: `วันที่ ${
              data.start_date
                ? moment(data.start_date).add(543, 'year').format('DD/MM/YYYY')
                : '-'
            }`,
            alignment: 'right'
          },

          {
            text: [
              {
                text:
                  '\t\t\t\t สัญญาฉบับนี้ทำขึ้นระหว่าง ' +
                  `${data?.org_th || '-'} ${data?.address1_th || '-'} ${
                    data?.address2_th || '-'
                  } (ซึ่งต่อไปนี้ ในสัญญานี้เรียกว่า "บริษัท") ฝ่ายหนึ่งกับ`,
                bold: false,

                preserveLeadingSpaces: true
              },
              {
                text: ` ${data?.title_th || '-'}${data?.name_th || '-'} ${
                  data?.surname_th || '-'
                }`,
                bold: true,
                // decoration: "underline",
                // decorationStyle: "dotted",
                preserveLeadingSpaces: true
              },

              {
                text: ' พนักงานตำแหน่ง ',
                bold: false,
                preserveLeadingSpaces: true
              },
              {
                text: data.position_th,
                bold: true,
                preserveLeadingSpaces: true
                // decoration: "underline",
                // decorationStyle: "dotted",
              },
              {
                text: ' (ซึ่งต่อไปจะเรียกว่า “พนักงาน”) อีกฝ่ายหนึ่ง ',
                bold: false,
                preserveLeadingSpaces: true
              }
            ],
            alignment: 'left',
            marginTop: 15
          },
          {
            text: [
              {
                text: '\t\tคู่สัญญาทั้งสองฝ่ายได้ตกลงกันที่จะทำสัญญาการเก็บรักษาข้อมูลที่เป็นความลับ (ซึ่งต่อไปจะเรียกว่า “สัญญา”) ดังนี้ ',
                bold: false,
                marginRight: 3,
                preserveLeadingSpaces: true
              }
            ],
            alignment: 'left',
            marginTop: 5
          },
          {
            text: [
              {
                text: '\t\t1.	“ข้อมูลความลับ” หมายถึง ข้อมูลใด ๆ ซึ่งบริษัทได้เปิดเผยให้แก่พนักงานตั้งแต่ระยะเวลาที่พนักงานเริ่มเข้าทำงานกับบริษัท โดยบริษัทประสงค์ให้พนักงานเก็บรักษาข้อมูลดังกล่าวไว้เป็นความลับ ซึ่งข้อมูลความลับดังกล่าว หมายความถึง ข้อมูลและความลับ ทางการค้า ความรู้เกี่ยวกับผลิตภัณฑ์ วิธีใช้ผลิตภัณฑ์ ข้อมูลและรายละเอียดด้านเทคนิค แผนและกลยุทธ์การดำเนินธุรกิจ ข้อมูลการเงินและการตลาด แผนการพัฒนาหรือค้นคว้าวิจัย ทั้งในรูปที่จับต้องได้และจับต้องไม่ได้ พร้อมกับการวิเคราะห์ รวบรวม การศึกษา เอกสารอื่น ๆ และบรรดาสำเนา บันทึก รายงาน ที่มีหรือแสดงโดยประการอื่นใดให้เห็นถึงข้อมูลดังกล่าวและเกี่ยวข้องกับ กิจการของบริษัท ซึ่งได้จัดเตรียมไว้โดยบริษัทหรือคำแนะนำของบริษัท หรือจัดทำโดยบุคคลอื่นที่ได้กระทำในนามของบริษัทที่ได้ เปิดเผยให้กับ พนักงาน ซึ่งพนักงานได้รับทราบข้อมูลไม่ว่าวิธีการใดในทางการงานที่เกี่ยวข้องกับการปฏิบัติงานของพนักงาน',
                bold: false,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t2.	พนักงานที่มีหน้าที่เกี่ยวข้องกับข้อมูลความลับ ความลับทางการค้า ความลับในการดำเนินธุรกิจ ขั้นตอนในการดำเนินธุรกิจ รายละเอียดหรือข้อมูลใด ๆ อันเกี่ยวกับบุคคล บัญชี การเงิน สินค้า/บริการ รายชื่อและรายละเอียดที่เกี่ยวข้องกับลูกค้าของบริษัท รวมถึงความลับในการทำธุรกรรมต่าง ๆ ของบริษัท ซึ่งพนักงานได้รับทราบระหว่างปฏิบัติหน้าที่ พนักงานรับรองและสัญญาว่า',
                bold: false,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t\t\t2.1.	ในระหว่างที่เป็นพนักงานของบริษัท และตลอดไปหลังจากนั้น พนักงานจะเก็บรักษาข้อมูลดังกล่าวด้วยความรับผิด ชอบและเก็บข้อมูลความลับไว้โดยครบถ้วน และเคร่งครัด ',
                bold: false,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t\t\t2.2. จะไม่กระทำการใช้ เอาไป หรือเปิดเผยข้อมูลไม่ว่าทั้งหมดหรือบางส่วนให้แก่บุคคลภายนอกที่ไม่มีส่วนเกี่ยวข้องกับการ ดำเนินธุรกิจของบริษัท เว้นแต่บริษัทอนุญาตไว้เป็นลายลักษณ์อักษร โดยพนักงานต้องไม่ใช้ข้อมูลความลับดังกล่าวกระทำการให้ บริษัทเสียหายไม่ว่าทางตรงหรือทางอ้อม',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t\t\t2.3.	พนักงานจะไม่ใช้ข้อมูลความลับเพื่อประโยชน์ของตนเอง หรือของผู้อื่นยิ่งไปกว่าประโยชน์ของบริษัท',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t3.	บรรดาข้อมูลความลับทั้งหลาย และผลงานของพนักงานที่ได้จากการปฏิบัติงาน ทั้งตามหน้าที่รับผิดชอบและตามคำสั่งของ ผู้บังคับบัญชาถือเป็นทรัพย์สินของบริษัทแต่ผู้เดียว พนักงานจะต้องดำเนินการอย่างใดอย่างหนึ่งตามที่บริษัทร้องขอ หรือเมื่อพนักงาน สิ้นสุดสัญญาการเป็นพนักงานของบริษัท ดังนี้',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t\t\t3.1.	ให้พนักงานส่งบรรดาเอกสารข้อมูลดังกล่าวข้างต้นที่พนักงานได้รับอันเนื่องมาจากการปฏิบัติงานให้แก่บริษัทในทันที',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t\t\t3.2.	ให้ทำลาย เพื่อเป็นการคุ้มครองตามระเบียบ หรือตามที่กฎหมายกำหนด และในกรณีที่ข้อมูลความลับถูกเก็บอยู่ใน เครื่องคอมพิวเตอร์ จะต้องทำการลบทิ้งรายการข้อมูลต่าง ๆ ที่มีอยู่ โดยที่ได้ผ่านการตรวจสอบจากบริษัท ซึ่งบริษัทจะต้องเป็นผู้ทำ การอนุมัติการลบทิ้งข้อมูลดังกล่าว',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t4.	หากพนักงานกระทำผิดหรือกระทำการฝ่าฝืนสัญญานี้ไม่ว่ากรณีใด ๆ พนักงานยินยอมให้บริษัทดำเนินคดีฟ้องร้องต่อศาล ได้ทันที และพนักงานจะต้องชดใช้ค่าเสียหายทั้งหมดให้แก่บริษัท',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t5.	ข้อผูกพันในการเก็บความลับตามสัญญาฉบับนี้ ยังคงมีผลใช้บังคับตลอดระยะเวลาที่เป็นพนักงานของบริษัท และเมื่อสัญญา ว่าจ้างพนักงานได้สิ้นสุดลงไม่ว่ากรณีใด ๆ ให้สัญญานี้ยังคงมีผลอยู่ต่อไปอีกเป็นเวลา 1 ปีภายหลังจากพ้นสภาพการเป็นพนักงานของ บริษัท เว้นแต่จะได้รับความยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจากบริษัท',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ],
            pageBreak: 'before',
            marginTop: 40
          },
          {
            text: [
              {
                text: '\t\t6.	พนักงานตกลงว่าจะไม่รับจ้างทำงานกับบุคคลใด นิติบุคคลใดที่ประกอบธุรกิจอันเป็นการแข่งขันกับบริษัทเป็นระยะเวลา 6 เดือนภายหลังพ้นสภาพการเป็นพนักงานของบริษัท เว้นแต่จะได้รับความยินยอมล่วงหน้าเป็นลายลักษณ์อักษรจากบริษัท',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t7.	ทั้งสองฝ่ายตกลงร่วมกันโดยให้ถือสัญญาฉบับนี้ เป็นส่วนหนึ่งของสัญญาจ้างงานของพนักงานด้วย',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t8.	หากเงื่อนไขหรือข้อตกลงใด ๆ ในสัญญาฉบับนี้ตกเป็นโมฆะ ไม่สมบูรณ์หรือขัดต่อกฎหมาย หรือใช้บังคับไม่ได้ไม่ว่าเพราะเหตุ ใด ๆ ก็ตาม พนักงานยินยอมให้เงื่อนไขหรือข้อตกลงใด ๆ ที่เป็นโมฆะ ไม่สมบูรณ์หรือขัดต่อกฎหมาย หรือใช้บังคับไม่ได้นั้นแยกออก จากเงื่อนไข หรือข้อตกลงส่วนที่สมบูรณ์และให้เงื่อนไข ข้อตกลงในส่วนที่สมบูรณ์มีผลใช้บังคับต่อไป',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            text: [
              {
                text: '\t\t สัญญาฉบับนี้ทำขึ้นสองฉบับมีข้อความถูกต้องตรงกันคู่สัญญาทั้งสองฝ่ายได้อ่านข้อความตามสัญญา โดยตลอดแล้วเห็นว่าตรง ตามเจตนารมย์ของคู่สัญญาแล้วทุกประการ ทั้งสองฝ่ายจึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน',
                margin: 5,
                preserveLeadingSpaces: true
              }
            ]
          },
          {
            columns: [
              {
                text: '.',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true,
                width: 250,
                marginTop: 20,
                color: 'white'
              },

              {
                stack: [
                  {
                    image: 'imgSignatureCEO',
                    width: 150,
                    alignment: 'center',
                    marginTop: 15,
                    marginBottom: -15
                    // marginLeft: 40,
                  },
                  {
                    text: 'ลงชื่อ .....................................................บริษัท',
                    alignment: 'center',
                    marginTop: 5
                    // marginRight: 20,
                  },

                  {
                    text: `( ${signatureCEO?.title_th || '               '} ${
                      signatureCEO?.name_th || '               '
                    } ${signatureCEO?.surname_th || '               '} )`,

                    bold: false,
                    alignment: 'center',
                    preserveLeadingSpaces: true,
                    marginTop: -3
                  },
                  {
                    text: [
                      {
                        text:
                          'วันที่ ' +
                          `${
                            data.start_date
                              ? moment(data.start_date)
                                  .add(543, 'year')
                                  .format('DD/MM/YYYY')
                              : '......................................'
                          }`,
                        bold: false,
                        alignment: 'center',
                        preserveLeadingSpaces: true
                      }
                    ],
                    marginTop: -3
                    // marginRight: 75,
                  }
                ]
              }
            ]
          },

          {
            columns: [
              {
                text: '.',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true,
                width: 250,
                marginTop: 10,
                color: 'white'
              },

              {
                stack: [
                  {
                    image: 'imgSignatureEMP',
                    width: 150,
                    alignment: 'center',
                    marginTop: 10,
                    marginBottom: -15
                    // marginLeft: 40,
                  },
                  {
                    text: 'ลงชื่อ .....................................................พนักงาน',
                    alignment: 'center',
                    marginTop: -3
                    // marginRight: 20,
                  },

                  {
                    text: `( ${signatureEMP?.title_th || '               '} ${
                      signatureEMP?.name_th || '               '
                    } ${signatureEMP?.surname_th || '               '} )`,

                    bold: false,
                    alignment: 'center',

                    preserveLeadingSpaces: true,

                    // marginRight: 50,
                    marginTop: -3
                  },
                  {
                    text: [
                      {
                        text:
                          'วันที่ ' +
                          `${
                            data.start_date
                              ? moment(data.start_date)
                                  .add(543, 'year')
                                  .format('DD/MM/YYYY')
                              : '......................................'
                          }`,
                        bold: false,
                        alignment: 'center',
                        preserveLeadingSpaces: true
                      }
                    ],
                    marginTop: 0
                    // marginRight: 75,
                  }
                ]
              }
            ]
          },

          {
            columns: [
              {
                text: '.',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true,
                width: 250,
                marginTop: 10,
                color: 'white'
              },

              {
                stack: [
                  {
                    image: 'imgSignaturePD',
                    width: 150,
                    alignment: 'center',
                    marginTop: 10,
                    marginBottom: -15
                    // marginLeft: 40,
                  },
                  {
                    text: 'ลงชื่อ ...........................................................พยาน',
                    alignment: 'center',
                    marginTop: -3
                    // marginRight: 20,
                  },

                  {
                    text: `( ${signatureVP?.title_th || '               '} ${
                      signatureVP?.name_th || '               '
                    } ${signatureVP?.surname_th || '               '} )`,

                    bold: false,
                    alignment: 'center',

                    preserveLeadingSpaces: true,

                    // marginRight: 50,
                    marginTop: -3
                  },
                  {
                    text: [
                      {
                        text:
                          'วันที่ ' +
                          `${
                            data.start_date
                              ? moment(data.start_date)
                                  .add(543, 'year')
                                  .format('DD/MM/YYYY')
                              : '......................................'
                          }`,
                        bold: false,
                        alignment: 'center',
                        preserveLeadingSpaces: true
                      }
                    ],
                    marginTop: 0
                    // marginRight: 75,
                  }
                ]
              }
            ]
          },
          {
            columns: [
              {
                text: '.',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true,
                width: 250,
                marginTop: 10,
                color: 'white'
              },

              {
                stack: [
                  {
                    image: 'imgSignatureTO',
                    width: 150,
                    alignment: 'center',
                    marginTop: 10,
                    marginBottom: -15
                    // marginLeft: 40,
                  },
                  {
                    text: 'ลงชื่อ ...........................................................พยาน',
                    alignment: 'center',
                    marginTop: 5
                    // marginRight: 20,
                  },

                  {
                    text: `( ${signatureTO?.title_th || '               '} ${
                      signatureTO?.name_th || '               '
                    } ${signatureTO?.surname_th || '               '} )`,

                    bold: false,
                    alignment: 'center',

                    preserveLeadingSpaces: true,

                    // marginRight: 50,
                    marginTop: -3
                  },
                  {
                    text: [
                      {
                        text:
                          'วันที่ ' +
                          `${
                            data.start_date
                              ? moment(data.start_date)
                                  .add(543, 'year')
                                  .format('DD/MM/YYYY')
                              : '......................................'
                          }`,
                        bold: false,
                        alignment: 'center',
                        preserveLeadingSpaces: true
                      }
                    ],
                    marginTop: -3
                    // marginRight: 75,
                  }
                ]
              }
            ]
          }
        ],
        footer: function (cp, pc, ps) {
          //add logic
          return {
            stack: [
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 0,
                    x2: 500,
                    y2: 0,
                    margin: [20, 10, 20, 0], //ซ้าย บน ขวา ล่าง
                    lineWidth: 0.2,
                    lineColor: 'black'
                  }
                ],
                // marginTop: -20,
                marginBottom: 10,
                alignment: 'center'
              },

              {
                text: `${data.org_th} ${data.address1_th} ${data.address2_th} โทรศัพท์: ${data.tel_no} โทรสาร: ${data.fax_no}`,

                color: '#464EA4',
                fontSize: 6,
                alignment: 'left',
                margin: [30, 0, 30, 0], //ซ้าย บน ขวา ล่าง
                lineHeight: 1.2
              },
              {
                text: `${data.org_en} ${data.address1_en} ${data.address2_en} Telephone: ${data.tel_no} Fax: ${data.fax_no}`,
                color: '#464EA4',
                fontSize: 6,
                alignment: 'left',
                margin: [30, 0, 30, 0], //ซ้าย บน ขวา ล่าง
                lineHeight: 1.2
              },
              {
                text: ` ${cp} of ${pc}`,
                alignment: 'center',
                bold: true,
                margin: [0, 10, 0, 10],
                marginBottom: 0,
                fontSize: 8
              }
            ]
          }
        },
        // footer: function (cp, pc, ps) {
        //   //add logic
        //   return {
        //     columns: [
        //       [
        //         {
        //           text: `Page ${cp} of ${pc}`,
        //           alignment: "center",
        //           bold: true,
        //           fontSize: 9,
        //         },
        //       ],
        //     ],
        //   };
        // },

        pageSize: 'A4',
        defaultStyle: {
          fontSize: 10,
          bold: false,
          font: 'THSarabunNew',
          lineHeight: 1.6,
          alignment: 'justify'
        },
        pageMargins: [40, 50, 40, 60] //ซ้าย บน ขวา ล่าง
      })
      if (isChecked === 1) {
        file.getBlob((blob) => {
          onSubmitEdit(blob)
        })
      } else {
        file.open()
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Fail!',
        text: error,
        customClass: {
          confirmButton: 'btn btn-success'
        }
      })
    }
  }
  const [isSave, setIsSave] = useState(false)

  const onSubmitEdit = (file) => {
    var formData = new FormData()
    formData.append('orgId', orgId)
    formData.append('file', file)
    formData.append('contractNo', contractNo)

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to confirm?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateContractConfirm(formData)
      }
    })
  }

  const updateContractConfirm = async (param) => {
    const datas = await updateSecretAPI(param)
    setIsSave(false)
    if (!datas) return
    if (datas.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getContractDetail()
      })
    } else {
      Error_false(datas)
    }
  }

  return (
    <>
      {/* {isLoading && */}
      <div
        className="p-3 d-flex d-flex justify-content-between bg-white"
        style={{ position: 'sticky', top: '0px' }}
      >
        <span className="d-flex gap-3 rounded-top pointer-event">
          <NavContract />
        </span>

        <div className="gap-3 d-flex ">
          {isCheck2 === 1 ? (
            <>
              {/* {detailFile && (
                <a
                  href={detailFile}
                  target="_blank"
                  onClick={() => getContractDetailFile()}
                  onChange={() => {
                    setOnLoad(true)}}
                > */}
              <Button
                size="sm"
                style={{ maxHeight: '33px' }}
                onClick={() => getContractDetailFile()}
              >
                <Image
                  style={{
                    width: '10px',
                    marginRight: 5
                  }}
                  className="mb-1 "
                  src={imgDownload}
                />
                Download PDF
              </Button>
              {/* </a>
              )} */}
            </>
          ) : (
            <>
              <Button
                variant="outline-secondary"
                style={{ maxHeight: '33px' }}
                size="sm"
                onClick={() => {
                  exportPDF(1)
                }}
              >
                Confirm
              </Button>
              <Button
                onClick={() => {
                  exportPDF(2)
                }}
                size="sm"
                style={{ maxHeight: '33px' }}
              >
                <Image
                  style={{
                    width: '10px',
                    marginRight: 5
                  }}
                  className="mb-1 "
                  src={imgDownload}
                />
                Download PDF
              </Button>
            </>
          )}
        </div>
      </div>
      {/* } */}
    </>
  )
}
